import { render } from "./old-version-alert.vue?vue&type=template&id=53c9aaa2&lang=pug"
import script from "./old-version-alert.vue?vue&type=script&setup=true&lang=js"
export * from "./old-version-alert.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__